import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-pricing-page',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './pricing-page.component.html',
  styleUrl: './pricing-page.component.css',
})
export class PricingPageComponent {

  sharedFeatures: Array<{ icon: string; title: string; desc: string }> = [
    { icon: 'ti-chart-bar',     title: 'RAR Dashboard',       desc: 'Comprehensive results analysis and reporting for every student' },
    { icon: 'ti-file-text',     title: 'Pre-Class Materials',  desc: 'Notes and resources shared before every live session' },
    { icon: 'ti-player-play',   title: 'Recorded Sessions',    desc: 'Revisit every class at your own pace anytime' },
    { icon: 'ti-history',       title: 'Error Log & Tracker',  desc: 'Track mistakes and monitor progress over time' },
    { icon: 'ti-bulb',          title: 'Weak Area Analysis',   desc: 'Highlight strengths and target gaps with precision' },
    { icon: 'ti-users',         title: '8 PTM Meetings',       desc: 'Regular parent–teacher consultations throughout the year' },
    { icon: 'ti-device-laptop', title: 'LMS Platform',         desc: 'Technology-driven learning management system access' },
    { icon: 'ti-credit-card',   title: 'Flexible Payments',    desc: 'Instalment options and a clear cancellation policy on all plans' }
  ];

  ngOnInit(): void {
    // Load Nunito font
    var link = document.createElement('link');
    link.rel  = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap';
    document.head.appendChild(link);

    // Load Tabler Icons
    var icons = document.createElement('link');
    icons.rel  = 'stylesheet';
    icons.href = 'https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css';
    document.head.appendChild(icons);

    // Scroll-reveal
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          (entry.target as HTMLElement).style.opacity = '1';
          (entry.target as HTMLElement).style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.08 });

    setTimeout(function() {
      var cards = document.querySelectorAll('.pc-card');
      cards.forEach(function(card, i) {
        var el = card as HTMLElement;
        el.style.opacity = '0';
        el.style.transform = 'translateY(24px)';
        el.style.transition = 'opacity 0.4s ease ' + (i * 0.08) + 's, transform 0.4s ease ' + (i * 0.08) + 's';
        observer.observe(el);
      });

      var items = document.querySelectorAll('.pc-share-item');
      items.forEach(function(item, i) {
        var el = item as HTMLElement;
        el.style.opacity = '0';
        el.style.transform = 'translateY(14px)';
        el.style.transition = 'opacity 0.35s ease ' + (i * 0.05) + 's, transform 0.35s ease ' + (i * 0.05) + 's';
        observer.observe(el);
      });
    }, 100);
  }

}